import { VillageDto } from "../dtos/VillageDto";
import { NotificationTypes } from "../enums/NotificationTypes";
import { UserGroup } from "../enums/UserGroup";
import { CardSwapStatusDto } from "../views/CardSwap/dtos/CardSwapStatusDto";
import { GridSortItem } from "@mui/x-data-grid";
import { ScheduleDto } from "../views/CommonDoorSchedule/dtos/ScheduleDto";

// TODO_DK: state slices when state is too complex

export type VspPortalState = {

    arrivalLogsPageNumber : number
    , arrivalLogsPageSize : number
    , arrivalLogsSorting : GridSortItem
    , cardSwapSearchResultPageNumber : number
    , cardSwapSearchResultPageSize : number
    , cardSwapSearchResultSorting : GridSortItem
    , cardSwapStatuses: CardSwapStatusDto[ ]
    , functionKey: string | null
    , isDarkTheme: boolean
    , notificationText: string
    , notificationType: NotificationTypes | undefined
    , schedule: ScheduleDto | undefined
    , userGroups: UserGroup[ ]
    , username: string
    , village: string
    , villages: { [ asset: string ] : VillageDto[ ]; }

};


export const initialVspPortalState : VspPortalState = {

    arrivalLogsPageNumber : 0
    , arrivalLogsPageSize : 20
    , arrivalLogsSorting : { field: 'surname', sort: 'asc' }
    , cardSwapSearchResultPageNumber : 0
    , cardSwapSearchResultPageSize : 20
    , cardSwapSearchResultSorting : { field: 'surname', sort: 'asc' }
    , cardSwapStatuses: [ ]
    , functionKey: null
    , isDarkTheme: false
    , notificationText: ''
    , notificationType: undefined
    , schedule: undefined
    , userGroups: [ ]
    , username: ''
    , village: ''
    , villages: { }

}; 